<template>
  <div class="toast-wrapper" v-if="visible" :style="wrapperStyle">
    <transition name="fade">
    <span v-html="content"></span>
    </transition>
  </div>
</template>

<script>
export default {
  name: "toast",

  props: {
    content: {
      type: String,
      default: '',
    },
    stayTime: {
      type: Number,
      default: 2000
    },
    withMask: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      visible: true,
    }
  },

  computed: {
    wrapperStyle() {
      return {
        pointerEvents: this.withMask ? 'auto' : 'none',
      }
    }
  },

  mounted() {
    if (this.stayTime > 0){
      setTimeout(() => {
        this.visible = false;
        this.$nextTick(() => {
          this.$emit('close');
        })
      }, this.stayTime);
    }
  }
}
</script>

<style lang="scss">
.toast-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 100;
  font-size: 3em;

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  span {
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    background: rgba(0,0,0, 0.8);
    color: #FFFFFF;
    padding: 0.5em 1em;
    text-align: center;
  }
}
</style>